const ODONTO_AUTO_PAYMENT_URL =
	'https://www.hapvida.com.br/pls/podontow/webNewDentalCliente.pr_login_cliente_opmenu?pOrgAmb=2&pOpMenu=11';

export {ODONTO_AUTO_PAYMENT_URL};
